/**!
 * Apricot D8
 * @version 4.2.0
 * @author Mitra Assadi, Nathan Henry
 * @license
 * Copyright (c) 2020 The College Board
 */

/* ========================================================================
 * Apricot's D8
 * ======================================================================== */

// SCSS
import '../scss/includes/apricot-d8.scss';

// javaScript
export default {};
